import React from "react";
import { Dialog, DialogContent, Box } from "@mui/material";
import PropTypes from "prop-types";

/**
 * Renders a dialog component for displaying an image in full size.
 * @param {Object} props - The component props.
 * @param {boolean} props.open - Whether the dialog is open.
 * @param {Function} props.onClose - Function to call when the dialog is closed.
 * @param {string} props.imageSrc - The source URL of the image to display.
 * @param {string} props.alt - The alt text for the image.
 * @returns {JSX.Element} The rendered ImageDialog component.
 */
export default function ImageDialog({ open, onClose, imageSrc, alt = "Image" }) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xl"
            fullWidth
        >
            <DialogContent sx={{ p: 0, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box
                    component="img"
                    src={imageSrc}
                    alt={alt}
                    sx={{
                        maxWidth: '100%',
                        height: 'auto',
                    }}
                />
            </DialogContent>
        </Dialog>
    );
}

ImageDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    imageSrc: PropTypes.string.isRequired,
    alt: PropTypes.string,
};

